<span mat-button class="page-settings-title">
  <span class="page-settings-title-text mx-auto">{{title}}</span>
  <mat-icon class="page-settings-title-icon" [matMenuTriggerFor]="options" matTooltip="{{'More' | translate}}">more_vert</mat-icon>
  <mat-menu class="more-menu" #options="matMenu">
    <button *ngIf="elementType < ElementType.PAGE" class="more-menu-item" mat-menu-item (click)="copyElement(elementType)" [disabled]="existOnList">
      <mat-icon>content_copy</mat-icon>
      <span>{{'To copy' | translate}}</span>
    </button>
    <button class="more-menu-item" mat-menu-item [matMenuTriggerFor]="pasteOptions" [disabled]="!hasSomethingToPaste">
      <mat-icon>content_paste</mat-icon>
      <span>{{'Paste' | translate}}</span>
    </button>
    <button class="more-menu-item delete" mat-menu-item (click)="clearElements()" [disabled]="copiedElements.length <= 0">
      <mat-icon>delete</mat-icon>
      <span>{{'Empty clipboard' | translate}}</span>
    </button>
  </mat-menu>
  <mat-menu class="more-menu" #pasteOptions="matMenu">
    <button
      *ngFor="let element of pasteableElements"
      class="more-menu-item" mat-menu-item
      (click)="pasteElement(element, elementType)"
      [disabled]="element.isDisabled"
      mat-menu-item
    >
      <span class="element-type">{{ElementType[element.type] | translate}}</span>
      <span>{{element.name}}</span>
      <span *ngIf="element.subname != undefined && element.subname != ''">{{element.subname}}</span>
    </button>
  </mat-menu>
</span>
